export default __webpack_public_path__ + "static/media/pic6.14c69e23.jpg";